module.exports = __webpack_public_path__ + "img/lot-02.59142291.webp";